// src/components/CategorySlider.js
import React from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "./CategorySlider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Import category images
import img1 from "../assets/categories_page-0001.jpg";
import img2 from "../assets/categories_page-0002.jpg";
import img3 from "../assets/categories_page-0003.jpg";
import img4 from "../assets/categories_page-0004.jpg";
import img5 from "../assets/categories_page-0005.jpg";
import img6 from "../assets/categories_page-0006.jpg";

const CategorySlider = () => {
  const navigate = useNavigate();
  
  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  const categories = [
    { id: 1, img: img1, title: "Luggage Bags" },
    { id: 2, img: img2, title: "Hard Luggage Bags" },
    { id: 3, img: img3, title: "Travel Bags" },
    { id: 4, img: img4, title: "School Bags" },
    { id: 5, img: img5, title: "Office Bags" },
    { id: 6, img: img6, title: "Ladies Purses" }
  ];

  const handleCategoryClick = (categoryId) => {
    navigate(`/products/${categoryId}`);
  };

  return (
    <div className="category-slider-container">
      <div className="category-slider">
        <Slider {...settings}>
          {categories.map((category) => (
            <div 
              key={category.id} 
              className="category-card"
              onClick={() => handleCategoryClick(category.id)}
            >
              <div className="category-img-container">
                <img src={category.img} alt={category.title} className="category-img" />
                <div className="category-overlay"></div>
              </div>
              <h3 className="category-title">{category.title}</h3>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CategorySlider;